import { createContext } from 'react';
import moment from 'moment';
import * as yup from 'yup';
import { isValidPhoneNumber } from 'react-phone-number-input';

export const CountryCodeContext = createContext('us');

/**
 *
 * @param {Array(objects)} currQuestions
 * @param {Array(objects)} dbQuestions
 * @param {Object} dbJumpData
 * @returns Formatted logicJumpData
 */

export const getLogicJumpData = (currQuestions, dbQuestions, dbJumpData) => {
  let newJumpData = [{ number: '' }];

  const questionsArray = Array.isArray(currQuestions)
    ? currQuestions
    : Array.isArray(dbQuestions)
    ? dbQuestions
    : null;

  /**
   * Remove questions which are no longer present in the form.
   * Creates a copy of response jump data.
   */
  if (Array.isArray(dbJumpData) && dbJumpData.length !== 0 && questionsArray) {
    const questionIdArray = questionsArray.map((item) => item.questionId);
    // Create a new array here because even though array filter returns a new array, the children elements share the same ref.
    newJumpData = JSON.parse(
      JSON.stringify(
        dbJumpData.filter((item, index) => {
          if (index > 0 && !questionIdArray.includes(item?.questionId)) {
            return false;
          }
          return true;
        }),
      ),
    );
  }

  /**
   * Make sure all answers are valid and in correct form.
   * Convert date from ISO string to moment object.
   */
  for (let i = 1; i < newJumpData.length; i++) {
    const question = questionsArray.find((item) => item.questionId === newJumpData[i].questionId);
    const answer = newJumpData[i].answer;
    switch (question.type) {
      case 'DATE': {
        newJumpData[i].answer = answer ? moment(newJumpData[i].answer) : null;
        break;
      }
      case 'CHECKBOX': {
        // Assumes questions.options is always an array, which it should be.
        newJumpData[i].answer = Array.isArray(answer)
          ? answer.filter((item) =>
              question.options.find((option) => option.label === item) ? true : false,
            )
          : null;
        break;
      }
      case 'RADIO':
      case 'DROPDOWN': {
        newJumpData[i].answer = question.options.find((option) => option.label === answer)
          ? answer
          : null;
        break;
      }
      case 'RATING': {
        newJumpData[i].answer = question.ratingStyle === 'star' && answer > 5 ? null : answer;
        break;
      }

      default:
    }
  }

  return newJumpData;
};

export const formSettingsSchema = yup.object().shape({
  name: yup.string().required('Form name cannot be empty'),
  link: yup.string().min(3).max(25).required(' Form link slug cannot be empty'),
  language: yup.string().required(),
  enabled: yup.boolean().required(),
  whatsappNumber: yup
    .string()
    .test('isPhoneNumberValid', 'Please enter a valid phone number', (value) => {
      return isValidPhoneNumber(`+${value}`);
    })
    .required(),
  meta: yup
    .object()
    .shape({
      title: yup.string(),
      desc: yup.string(),
      image: yup.string(),
      imageType: yup.string(),
    })
    .required(),
  responseJumpType: yup.string().oneOf(['default', 'sequence', 'logic']).default('default'),
  responseJumpData: yup
    .array()
    .of(
      yup.object().shape({
        number: yup
          .string()
          .required('Phone number field(s) cannot be empty.')
          .test('isPhoneNumberValid', 'Please enter a valid phone number(s)', (value) => {
            return isValidPhoneNumber(`+${value}`);
          }),

        questionId: yup.string(),
        answer: yup.mixed(),
      }),
    )
    .default([]),
  submitText: yup.string(),
  customDomain: yup.string(),
  pushNotificationEnabled: yup.boolean(),
  emailNotificationEnabled: yup.boolean(),
  emailNotificationEmail: yup.string().email('Please enter a valid email address'),
});
